import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders, apiErrorMessage } from '../headers';

import {
  AUDIT_LOGS_INDEX_REQUESTED,
  AUDIT_LOGS_INDEX_SUCCESS,
  AUDIT_LOGS_INDEX_FAILURE,
} from '../types';

const AUDIT_LOGS_LIMIT = 50;

// filters: { objectClass, objectId, userEmail, source, action }
export const auditLogsIndex = (filters = {}, continuationToken = null, append = false) => {
  return async (dispatch) => {
    dispatch({ type: AUDIT_LOGS_INDEX_REQUESTED, append: append });

    const endPoint = Config.baseUrl + Config.auditLogs;
    const params = { limit: AUDIT_LOGS_LIMIT };

    if (filters.objectClass) {
      params.object_class = filters.objectClass;
    }
    if (filters.objectId) {
      params.object_id = filters.objectId;
    }
    if (filters.userEmail) {
      params.user_email = filters.userEmail;
    }
    if (filters.source) {
      params.source = filters.source;
    }
    if (filters.action) {
      params.action = filters.action;
    }
    if (continuationToken) {
      params.continuation_token = continuationToken;
    }

    return Axios.get(endPoint, { headers: await authHeaders(), params: params })
      .then((response) => {
        dispatch({ type: AUDIT_LOGS_INDEX_SUCCESS, payload: response.data, append: append });
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: AUDIT_LOGS_INDEX_FAILURE, error: apiErrorMessage(error, 'Could not load the action history.') });
      });
  }
};
